import { ENDPOINTS, WEB_SOCKET_ENDPOINTS } from '../../constants/api'
import { getFormData, madeRequest } from '../../helpers/api'
import store from '../../store'
import { getAiMessageChunk, getSponsorFormIndustrySuggestionsChunk } from '../actions/tools'
import { madeSocketRequest } from '../../helpers/api/webSocket'

// PLOP_APPEND_PATTERN_ANCHOR

export async function getAiMessageService({ params, requestId, onSocketOpen }) {
  const handleStreamUpdate = parsedJson => {
    store.dispatch(getAiMessageChunk(parsedJson))
  }

  return madeSocketRequest(
    'post',
    {
      url: WEB_SOCKET_ENDPOINTS.streamAiSuggestions,
      params,
      requestId
    },
    {
      handleStreamUpdate,
      onSocketOpen
    }
  )
}

export function getSponsorFormIndustrySuggestionsService({ params, requestId }) {
  const handleStreamUpdate = parsedJson => {
    store.dispatch(getSponsorFormIndustrySuggestionsChunk(parsedJson))
  }

  return madeSocketRequest(
    'post',
    {
      url: WEB_SOCKET_ENDPOINTS.streamAiSuggestions,
      params,
      requestId,
      shouldParseJsonStream: true
    },
    {
      handleStreamUpdate
    }
  )
}

export function getAiConversationsService(params) {
  return madeRequest('GET', {
    params,
    url: ENDPOINTS.aiSuggestionsConversations
  })
}

export function getAiConversationMessagesService(params) {
  const { id } = params
  return madeRequest('GET', {
    params,
    url: `${ENDPOINTS.aiSuggestionsConversations}${id}/`
  })
}

export function getChangeHistoryService(params) {
  return madeRequest('GET', {
    params,
    url: ENDPOINTS.changeHistory
  })
}

export function getSelectorsService(params) {
  return madeRequest('GET', {
    url: ENDPOINTS.selectors,
    params
  })
}

export function updateSelectorService(data) {
  return madeRequest('POST', {
    url: ENDPOINTS.selectors,
    data: getFormData(data)
  })
}

export function updateAiConversationService(id, data) {
  return madeRequest('PATCH', {
    data,
    url: `${ENDPOINTS.aiSuggestionsConversations}${id}/`
  })
}
